import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { db, Student } from "../db";

interface EditStudentProps {
  student: Student;
  isOpen: boolean;
  onClose: () => void;
  updateStudents: () => void;
}

const EditStudent = ({
  student,
  isOpen,
  onClose,
  updateStudents,
}: EditStudentProps) => {
  const [name, setName] = useState<string>(student.name);
  const [dataCollectionConsent, setDataCollectionConsent] = useState<boolean>(
    student.dataCollectionConsent
  );

  const updateStudent = useCallback(async () => {
    try {
      await db.students.update(student.id!, {
        name,
        edited: true,
        dataCollectionConsent,
      });
    } catch (err) {
      console.error(`Failed to update student: ${err}`);
    }
    await updateStudents();
    onClose();
  }, [onClose, updateStudents, student, name, dataCollectionConsent]);

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      updateStudent();
    },
    [updateStudent]
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit student</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack as="form" onSubmit={handleSubmit} spacing={5}>
            <FormControl>
              <FormLabel>Student name</FormLabel>
              <Input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>

            <Tooltip
              label="Data for students where consent is not given will not be downloaded."
              hasArrow={true}
            >
              <FormControl alignSelf="flex-start" width="auto">
                <Checkbox
                  isChecked={dataCollectionConsent}
                  onChange={(e) => setDataCollectionConsent(e.target.checked)}
                >
                  <Text>Data collection consent</Text>
                </Checkbox>
              </FormControl>
            </Tooltip>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={updateStudent}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditStudent;
